'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledPath = _styledComponents2.default.path(_templateObject, function (props) {
  return props.theme[props.fill || 'color_white'];
});
var StyledSVG = _styledComponents2.default.svg(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var Minus = function Minus(_ref) {
  var fill = _ref.fill,
    width = _ref.width,
    height = _ref.height;
  return _react2.default.createElement(StyledSVG, {
    width: width,
    height: height,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 8.77 8.77'
  }, _react2.default.createElement('g', {
    id: '_8',
    'data-name': ' 8'
  }, _react2.default.createElement(StyledPath, {
    fill: fill,
    d: 'M7.78,5.53H3.91a.27.27,0,0,0,0,.55H7.78a.27.27,0,0,0,0-.55Z',
    transform: 'translate(-1.46 -1.4)'
  }), _react2.default.createElement(StyledPath, {
    fill: fill,
    d: 'M5.85,1.4a4.39,4.39,0,1,0,4.39,4.39A4.39,4.39,0,0,0,5.85,1.4Zm0,8.22A3.84,3.84,0,1,1,9.68,5.79,3.84,3.84,0,0,1,5.85,9.62Z',
    transform: 'translate(-1.46 -1.4)'
  })));
};
exports.default = Minus;